module.exports = __webpack_public_path__ + "static/box-bg.fffcbf4b.png";